import PropTypes from 'prop-types'
import {translations} from '@utils/languages'
import styled from '@emotion/styled'
import { ChevronDown } from './Svg'
import { useRef, useEffect } from 'react'

const LanguageSelect = ({ handleChange, language }) => {
	const selectRef = useRef()

	useEffect(() => {
		selectRef.current.value = language
	}, [language])

	return (
		<Wrap>
			<Select name="" id="" onChange={e => handleChange(e.target.value)} ref={selectRef}>
				<option value="en">English</option>
				{/* temporary filter for testing, needs to be removed once all content is translated */}
				{/* {translations?.filter(t => ['en', 'ar', 'zh-haus', 'hi', 'vi'].includes(t.code))?.map(t => 
					<option value={t.code}>{t.name}</option>
				)} */}
				{translations?.map(t => 
					<option value={t.code}>{t.name}{language.name !== 'English' ? ` – ${t.inLanguage}` : ''}</option>
				)}
			</Select>
			<StyledChevronDown/>
		</Wrap>
	)
}
const Wrap = styled.div`
	position: relative;
	margin-top: 2rem;
`
const Select = styled.select`
	display: inline-block;
	/* width: 300px; */
	padding: 0.6em 2.5em 0.6em;
	text-align: center;
	border-radius: 99px;
`

const StyledChevronDown = styled(ChevronDown)`
	width: 16px;
	position: absolute;
	right: 20px;
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none;
`

LanguageSelect.propTypes = {
}

export default LanguageSelect